export const SWITCH = 'SWITCH';
export const TAG_SWITCH = 'TAG_SWITCH';
export const AR_SWITCH = 'AR_SWITCH';